var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"labelBox",staticClass:"labels"},_vm._l((_vm.list),function(text){return _c('span',{key:text,staticClass:"label van-ellipsis",on:{"click":function($event){return _vm.onSelect(text)}}},[_vm._v(_vm._s(text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }